// Style
import "../styles/index.scss";

// Scripts
import "./vendors/jquery-3.7.1.min";
import "./vendors/bootstrap";
import "./vendors/validator.min";
import "./vendors/jquery.slicknav";
import "./vendors/jquery.waypoints.min";
import "./vendors/jquery.counterup.min";
import "./vendors/jquery.magnific-popup.min";
import "./vendors/function";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
